import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import "firebase/auth";

/* 
Config settings to the firebase
*/
export const firebaseConfig = {
  /* Local */
  // apiKey: "AIzaSyBMII55h0n7pbIR7gX0ogKftUlPriYHMiI",
  // authDomain: "valentineraffleapi.firebaseapp.com",
  // databaseURL: "https://valentineraffleapi.firebaseio.com",
  // projectId: "valentineraffleapi",
  // storageBucket: "valentineraffleapi.appspot.com",
  // messagingSenderId: "123668871295",

  // /* production */
  apiKey: "AIzaSyCe1O2YrByJU73ahoURosTcC6rqYdfncZM",
  authDomain: "lbcemp.firebaseapp.com",
  databaseURL: "https://lbcemp.firebaseio.com",
  projectId: "lbcemp",
  storageBucket: "lbcemp.appspot.com",
  messagingSenderId: "91247889322"
};

//export var firebaseConfg = firebaseConfig;

/* 
Init the firebase
*/

export const firebaseApp = firebase.initializeApp(firebaseConfig);

/* 
setting firestore 
*/

const firestore = firebaseApp.firestore();

export default firestore;
